export type BranchForMaps = {
  nombre?: string | null;
  direccion?: string | null;
  codigoPostal?: string | null;
  latitud?: string | null;
  longitud?: string | null;
} | null | undefined;

export const mapsUrlBuilder = {
  buildBranchUrl: (providerName?: string | null, branch?: BranchForMaps): string | null => {
    const parts = [
      providerName?.trim(),
      branch?.nombre?.trim(),
      branch?.direccion?.trim(),
      branch?.codigoPostal?.trim(),
      "Argentina",
    ].filter(Boolean) as string[];

    const textQuery = parts.join(" ");

    if (textQuery) {
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(textQuery)}`;
    }

    if (branch?.latitud && branch?.longitud) {
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        `${branch.latitud},${branch.longitud}`
      )}`;
    }

    return null;
  },
};
